import axios from 'axios';

export const putExpress = (path, body, callback) => {
  return axios.put(`/api${path}`, body)
  .then((response) => {
    callback(response);
  })
}

export const getExpress = (path, callback) => {
  return axios.get(`/api${path}`)
  .then((response)=>{
    callback(response);
  })
}

export const getExpressParams = (path, params, callback) => {
  return axios.get(`/api${path}`, {
    params: params
  })
  .then((response) => {
    callback(response);
  })
}

export const postExpress = (path, body, callback) => {
  return axios.post(`/api${path}`, body)
  .then((response) => {
    callback(response);
  })
}

export const deleteExpressParams = (path, params, callback) => {
  return axios.delete(`/api${path}`, {
    params: params
  })
  .then((response)=>{
    callback(response);
  })
}